import { createFileRoute, redirect } from '@tanstack/react-router';
import { PROTECTED, REGISTRY } from '@/lib/constants/routes';
import { REGISTRY_TABS } from '@/pages/registry/constants/tabs';

// Backward-compat: i Prodotti vivono ora sotto Anagrafica.
export const Route = createFileRoute('/protected/_layout/products/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: `${PROTECTED}${REGISTRY}`,
      search: { tab: REGISTRY_TABS.PRODUCTS },
    });
  },
});
